var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3299 3.7059L14.2474 0.61223C13.8451 0.232969 13.3179 0.0153549 12.7661 0.000782175C12.2143 -0.0137905 11.6765 0.175695 11.2549 0.533195L1.12974 10.6949C0.766098 11.0629 0.539677 11.5453 0.488484 12.061L0.00472837 16.7693C-0.0104267 16.9347 0.0109546 17.1014 0.0673479 17.2575C0.123741 17.4136 0.213758 17.5553 0.330982 17.6725C0.436103 17.7772 0.560773 17.86 0.697841 17.9162C0.83491 17.9724 0.981682 18.0008 1.12974 18H1.23099L5.92229 17.5709C6.4362 17.5196 6.91684 17.2923 7.28356 16.9274L17.4087 6.76569C17.8017 6.34902 18.014 5.793 17.9993 5.21946C17.9845 4.64592 17.7438 4.10164 17.3299 3.7059ZM5.71979 15.3128L2.34475 15.6289L2.64851 12.2417L9.00483 5.94146L12.0424 8.98997L5.71979 15.3128ZM13.5049 7.47701L10.4898 4.45108L12.6836 2.19293L15.7549 5.27531L13.5049 7.47701Z",
    fill: "#6F7E9A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.4dba1b6a54573da2aba76f4f2eaef7f8.svg";
export { ForwardRef as ReactComponent };